import { createSlice } from '@reduxjs/toolkit';
import { loginUser, logoutUser, verifyUserMobileNumber } from './auth.actions';
import initialState from './auth.initialState';

export const authSlice = createSlice({
  name: 'authSlice',
  initialState: initialState,
  reducers: {
    setIsLoggedIn: (state, action) => {
      state.isLoggedIn = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginUser.fulfilled, (state, action) => {
        if (!action.payload?.currentUser?.is_verified_user) {
          state.isLoggedIn = false;
        } else {
          state.isLoggedIn = true;
        }
      })
      .addCase(logoutUser.fulfilled, (state) => {
        state.isLoggedIn = false;
      })
      .addCase(verifyUserMobileNumber.fulfilled, (state) => {
        state.isLoggedIn = true;
      });
  },
});

export const { setIsLoggedIn } = authSlice.actions;
